import { useEffect } from 'react'
import { getToken, onMessage } from 'firebase/messaging'
import { getMessagingInstance } from '../services/firebase'
import { saveFcmToken } from '../services/auth'
import { getSession } from '../services/auth'

export interface IncomingTingl {
  tinglId: string
  vibeKey: string
  vibeEmoji: string
  vibeColor: string
  vibeLabel: string
  phrase: string
  fromName: string
  fromUid: string
}

const VAPID_KEY = process.env.REACT_APP_VAPID_KEY

export function useFCM(onTinglReceived: (data: IncomingTingl) => void) {
  useEffect(() => {
    const session = getSession()
    if (!session) return

    let unsubscribe: (() => void) | null = null

    const init = async () => {
      const messaging = await getMessagingInstance()
      if (!messaging) return

      // Request notification permission
      const permission = await Notification.requestPermission()
      if (permission !== 'granted') return

      // Get FCM token and save to user doc
      try {
        const token = await getToken(messaging, { vapidKey: VAPID_KEY })
        if (token) await saveFcmToken(token)
      } catch (err) {
        console.warn('FCM token error:', err)
      }

      // Foreground message handler — app is open
      unsubscribe = onMessage(messaging, (payload) => {
        const data = payload.data as any
        if (data?.type === 'TINGL_RECEIVED' || data?.type === 'KNOCK_RECEIVED') {
          // Haptic on receive
          if ('vibrate' in navigator) {
            navigator.vibrate([80, 30, 80])
          }
          // Trigger full-screen detonation
          onTinglReceived({
            tinglId:   data.tinglId,
            vibeKey:   data.vibeKey,
            vibeEmoji: data.vibeEmoji,
            vibeColor: data.vibeColor,
            vibeLabel: data.vibeLabel,
            phrase:    data.phrase,
            fromName:  data.fromName,
            fromUid:   data.fromUid || '',
          })
        }
      })
    }

    init()
    return () => { unsubscribe?.() }
  }, [onTinglReceived])
}
